import { useUpdate } from "react-use";
import { useAllSession } from "./useAllSession";
import { useEffect, useMemo } from "react";
import { ChatEvent } from "../store";

export function useSession(sessionId: string) {
    const update = useUpdate();
    const { sessions } = useAllSession();

    const session = useMemo(
        () => sessions.find(item => item.guid === sessionId),
        [sessionId]
    );

    useEffect(() => {
        const listener = (data: any) => {
            if (data.id === sessionId) update();
        };

        ChatEvent.on("SessionUpdate", listener);

        return () => {
            ChatEvent.off("SessionUpdate", listener);
        };
    }, []);

    return { session };
}
